import type { JSX } from 'react';

import { translationKey } from '@change-corgi/core/i18n';

import { useSharingTools } from '../../../../hooks/useSharingTools/variant2';
import { SharingToolsCardWrapperVariant2 } from '../../../SharingToolsCardWrapper/variant2';
import { PosterPreview } from '../PosterPreview';

export function QRPosterCard(): JSX.Element {
	const { data, actions } = useSharingTools();
	return (
		<SharingToolsCardWrapperVariant2
			Preview={<PosterPreview posterTemplate={data.posters.template} />}
			titleKey={translationKey('corgi.petition.starter_dashboard_v2.sharing_tools.qr_poster.title')}
			descriptionKey={translationKey('corgi.petition.starter_dashboard_v2.sharing_tools.qr_poster.description')}
			primaryActionTextKey={translationKey(
				'corgi.petition.starter_dashboard_v2.sharing_tools.qr_poster.primary_action_text',
			)}
			primaryActionOnClick={actions.openFlyerDownloadModal}
		/>
	);
}
